import { DateTime } from 'luxon'
import { parseDate } from '../../helpers/dateHelper'

export enum QuantityType {
    Numeric = 'NUMERIC',
    Time = 'TIME',
    Distance = 'DISTANCE',
}

export enum PricePrecedence {
    Subtotal = 'SUBTOTAL',
    Total = 'TOTAL',
    Inherited = 'INHERITED',
}

export type QuantityDto = {
    id: string
    type: QuantityType
    amount: string
    rate: string
}

export type PriceSummaryDto = {
    id?: string
    precedence: PricePrecedence
    currency: string
    subtotal: string
    total: string
}

export type PriceVatDto = {
    id: string
    value: string
    type: string
}

export type PriceDto = PriceSummaryDto & {
    vat: PriceVatDto[]
}

export type BaseTierDto = {
    type: string
    userId: string
    validFrom?: Date
    validTo?: Date
    salesRate: string
    currency?: string
}

export type TierDto = BaseTierDto & {
    purchaseRate: string
}

export type InsolvencyTierDto = BaseTierDto & {
    role: string
    estateRate: string
    factorExperience: string
    factorEstate: string
    factorTotal: string
}

export function isNormalTier(tier: BaseTierDto): tier is TierDto {
    return tier.type === 'TIER'
}

export function isInsolvencyTier(tier: BaseTierDto): tier is InsolvencyTierDto {
    return tier.type === 'INSOLVENCY_TIER'
}

export function isActiveTier(tier: BaseTierDto, date?: DateTime): tier is InsolvencyTierDto {
    if (!date) {
        date = DateTime.now().startOf('day')
    }

    return (
        (!tier.validFrom && !tier.validTo) ||
        (!tier.validFrom && parseDate(tier.validTo).diff(date).toMillis() > 0) ||
        (!tier.validTo && parseDate(tier.validFrom).diff(date).toMillis() < 0)
    )
}
